import { CriteriaStoredValue } from '@constants'
import { POSTStoredValueType } from '@types'

/**
 * преобразование массива с заполненными значениями для сохранения поиска
 * @param storedValues массив с заполненными значениями у критерий
 * @returns {POSTStoredValueType[]} - преобразованный массив для отправки
 */
class SearchAssistantStoredValueMapper {
  static toDto(storedValuesModel: CriteriaStoredValue[]): POSTStoredValueType[] {
    return storedValuesModel.map(({ id, value, searchRule, valueType, dailyRange, fieldType }) => ({
      valueId: id,
      value: JSON.stringify(value),
      searchRule,
      valueType,
      dailyRange: dailyRange ?? undefined,
      fieldType,
    }))
  }
}

export { SearchAssistantStoredValueMapper }
